export const mockServicepointService = (): {
  updateStatusServicepoint: jest.Mock<any, any>;
  getServicepointLimits: jest.Mock<any, any>;
  getServicepoint: jest.Mock<any, any>;
  getServicepoints: jest.Mock<any, any>;
  saveUpdateServicepoint: jest.Mock<any, any>;
  postGenerateServicePointReport: jest.Mock<any, any>;
  syncServicepoint: jest.Mock<any, any>;
} => ({
  getServicepoints: jest.fn(),
  getServicepoint: jest.fn(),
  getServicepointLimits: jest.fn(),
  saveUpdateServicepoint: jest.fn(),
  updateStatusServicepoint: jest.fn(),
  postGenerateServicePointReport: jest.fn(),
  syncServicepoint: jest.fn(),
});
